module.exports = __webpack_public_path__ + "static/media/upload.6d8c9579.svg";